module.exports = __webpack_public_path__ + "static/cosi4-afcec55f10c6911366aed45f19bf015b.jpg";